import LOGO from "../images/Nogaleros.png";

export const Team__Nogaleros = {
  name: "Nogaleros",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#2BA33E",
  teamJerseyColor: "#012500",

  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 30 + 47 +32,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,


  dontShowPointDif: true,

  players: [
    {
      goalsScored: 47 + 49 + 60,
    },
  ],
};
